import Api from '@/lib/api-wrapper';
import RequestUtils from '@/components/util/RequestUtils';

export default {
  mixins: [RequestUtils],
  methods: {
    async fetchCustomDomains() {
      this.commitRequest({
        request: async () => {
          const response = await Api.axios({
            url: 'custom-domains',
            method: 'GET',
          });

          // In V3 we only care about legacy custom domains so we filter out any new custom domains
          const legacyCustomDomains = response.customDomains.filter((domain) => {
            // Check if the domain is a legacy custom domain
            const domainParts = domain.replace(/^\/+|\/+$/g, '').split('/');
            const isV3Domain = domainParts.length > 1; // V3 domains have more than one part
            return isV3Domain;
          });

          this.domainData = response;
          this.domainData.customDomains = legacyCustomDomains;
          this.hasCustomDomains = !!(response && response.customDomains.length > 0);
          this.isLoading = false;

          return response;
        },
        onError: (errors) => {
          this.error = errors;
          this.hasCustomDomains = false;
          this.isLoading = false;
        },
        globalLoading: false, // Handle loading locally instead of globally
      });
    },
  },
  data() {
    return {
      isLoading: true,
      hasCustomDomains: false,
      domainData: null,
      error: null,
      constants: {
        DASHBOARD_PLANS_URL: `${process.env.VUE_APP_DASHBOARD_URL}/settings/billing/plans`,
        LEARN_MORE_URL: 'https://docs.knack.com/docs/custom-domains',
        REQUEST_URL: 'https://share.hsforms.com/1dsVcah_5So6NJmFWExLg4wdv4mq?affected_feature___component=Custom%20Domain',
        CONTACT_SUPPORT: 'mailto:support@knack.com',
      },
    };
  },
};
